// extracted by mini-css-extract-plugin
export var header = "_w7-1";
export var maskBottom = "_w7-6";
export var maskMiddle = "_w7-7";
export var maskTop = "_w7-5";
export var root = "_w7-0";
export var scrollDownButton = "_w7-3";
export var scrollDownButtonHidden = "_w7-4";
export var viewport = "_w7-2";